import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WEBHOOK_URL = 'https://chuckles.fluffyclient.com/hook/chucksmojis?k=_QPPbQpws1O94dhaOqbUY3Sn';

// Last page reported this session, so a re-run of the effect for the same
// location (StrictMode's dev double-invoke, a hash-only change) doesn't send
// a duplicate ping.
let lastReported: string | null = null;

/**
 * Pings the visit webhook once per page view, telling it which page the
 * visitor landed on. Fire-and-forget: the site never waits on or reacts to
 * the response, and a failed call is silently ignored.
 */
export default function VisitBeacon() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === lastReported) return;
    lastReported = pathname;

    const url = `${WEBHOOK_URL}&page=${encodeURIComponent(pathname)}`;
    const body = JSON.stringify({
      page: pathname,
      url: window.location.href,
      referrer: document.referrer,
      visitedAt: new Date().toISOString(),
    });

    // `no-cors` so the ping goes out even if the webhook host doesn't send
    // CORS headers; `keepalive` lets it complete if the visitor navigates away.
    fetch(url, {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain' },
      body,
    }).catch(() => {
      /* analytics ping — never surface a failure to the visitor */
    });
  }, [pathname]);

  return null;
}
